module.exports = __webpack_public_path__ + "static/media/infoJumbo3.b03dda03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/msmarking/images/infoJumbo3.jpg
// module id = 527
// module chunks = 0